<template>
  <div class="flex min-h-screen items-center justify-center bg-primary p-4 font-sans">
    <!-- Outer Frame -->
    <div
      class="w-full max-w-sm space-y-8 rounded-2xl border border-tertiary bg-secondary p-10 text-center shadow-2xl"
    >
      <div class="flex flex-col items-center gap-8">
        <!-- Header -->
        <div class="text-center">
          <CodeLabIcon class="h-30 w-30" />
          <p class="mt-1 text-sm font-bold uppercase tracking-widest text-text-main/30">
            Anmelden / Registrieren
          </p>
        </div>
        <!-- Login Actions -->
        <div class="w-full flex flex-col gap-4">
          <button
            type="button"
            data-testid="login-thl"
            class="flex items-center justify-center gap-3 rounded-lg bg-accent px-6 py-3.5 font-bold text-text-main shadow-lg transition-all hover:brightness-110 active:scale-[0.98]"
            @click="handleGitLabLogin"
          >
            Anmelden mit THL-Account
          </button>
          <div class="relative flex items-center justify-center py-2">
            <div class="absolute w-full border-t border-tertiary/50" />
            <span
              class="relative bg-secondary px-4 text-[10px] font-bold uppercase tracking-widest text-text-main/30"
              >oder</span
            >
          </div>
          <button
            type="button"
            data-testid="login-guest"
            :disabled="isLoggingIn"
            class="flex items-center justify-center gap-3 rounded-lg border-2 border-accent/30 bg-accent/5 px-6 py-3 font-bold text-accent transition-all hover:bg-accent/10 disabled:opacity-50 active:scale-[0.98]"
            @click="handleGuestLogin"
          >
            <span v-if="!isLoggingIn">Weiter als Gast</span>
            <span v-else class="flex items-center gap-2">
              <span
                class="h-4 w-4 animate-spin rounded-full border-2 border-accent border-t-transparent"
              ></span>
              Verbinde...
            </span>
          </button>
        </div>
        <p class="text-center text-[11px] leading-relaxed text-text-main/40 px-4">
          Gast Accounts sind temporär und werden automatisch nach 20 Stunden entfernt, oder wenn du
          dich Abmeldest
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { API_BASE_URL } from '../config'
import CodeLabIcon from '@/components/CodeLabLogoFull.vue'

const emit = defineEmits<{
  (e: 'login-success'): void
}>()

const isLoggingIn = ref(false)
async function handleGitLabLogin() {
  const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
    credentials: 'include',
  })
  const data = await response.json()
  if (data.auth_url) {
    window.location.href = data.auth_url
  }
}

async function handleGuestLogin() {
  isLoggingIn.value = true
  try {
    const response = await fetch(`${API_BASE_URL}/api/auth/guest`, {
      method: 'POST',
      credentials: 'include',
    })
    const data = await response.json()
    if (data.success) {
      emit('login-success')
    }
  } catch (error) {
    console.error('Guest-Login failed:', error)
  } finally {
    isLoggingIn.value = false
  }
}
</script>

<style scoped></style>
